// extracted by css-extract-rspack-plugin
export default {"listItem":"UserPicker_listItem__efKMp"};